import { Stack } from "@mui/material";
import { Illustration, Text } from "@src/appV2/redesign/system/ui-components";

export function BookingRequestsEmptyPageState() {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={8} flexGrow={1}>
      <Illustration type="browse-shifts" />
      <Text variant="body1">You don&apos;t have any pending booking requests.</Text>
    </Stack>
  );
}
